<template>
    <div>
        <b-navbar toggleable="lg" type="dark" variant="default" class="navbar">
            <!--      <b-navbar-brand to="/">Home</b-navbar-brand>-->

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item to="/">Home</b-nav-item>
                </b-navbar-nav>

                <!--<b-navbar-nav>
        <b-nav-item-dropdown text="Blogs">
            <b-dropdown-item to="/blog/managing-sql-server-databases-in-visual-studio">SQL Server Database Management with Visual Studio</b-dropdown-item>
            <b-dropdown-item to="/blog">Kafka - An Introduction</b-dropdown-item>
        </b-nav-item-dropdown>
    </b-navbar-nav>-->

                <b-navbar-nav>
                    <b-nav-item to="/blog">Blogs</b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav>
                    <b-nav-item to="/kb">Knowledge Base</b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav>
                    <b-nav-item to="/news">News</b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav>
                    <b-nav-item to="/tips">Tips &amp; Tools</b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav>
                    <b-nav-item to="/about">About Me</b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav>
                    <b-nav-item to="/mycv">Employers</b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav v-if="isAdmin">
                    <b-nav-item to="/editor">Editor</b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav v-if="isAdmin">
                    <b-nav-item to="/unpublished">Draft</b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav>
                    <b-nav-item to="/signin" v-if="! isSignedIn">Sign In</b-nav-item>
                    <b-nav-item v-if="isSignedIn" v-on:click="signOut">Sign Out</b-nav-item>
                </b-navbar-nav>

            </b-collapse>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-form>
                    <b-form-input v-model="query" size="sm" class="mr-sm-2 search" placeholder="Keywords"></b-form-input>
                    <b-button v-on:click.prevent="search" size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
                </b-nav-form>

                            <!--<b-nav-item-dropdown right>
                    <template #button-content>
                        <em>User</em>
                    </template>
                    <b-dropdown-item href="#">Profile</b-dropdown-item>
                    <b-dropdown-item href="#">Sign Out</b-dropdown-item>
                </b-nav-item-dropdown>-->
            </b-navbar-nav>

        </b-navbar>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from 'vue-property-decorator';

    @Component
    export default class Navigation extends Vue {
        private query: string = "";
        search(): void {
            if (this.query.trim().length > 0) {
                if (this.$route.name !== "search" || (this.$route.name === "search" && this.$route.params.query !== this.query)) {
                    this.$router.push({ name: "search", params: { query: this.query } });
                }
            }
        }

        signOut(): void {
            this.$store.commit("isAdmin", false);
            this.$store.commit("isSignedIn", false)
            sessionStorage.removeItem("authorization");
            this.$router.push("/");
        }

        get isAdmin() {
            return this.$store.state.isAdmin;
        }

        get isSignedIn() {
            return this.$store.state.isSignedIn;
        }
    }
</script>

<style scoped>

    .bg-default {
        background-color: #192a56;
    }

    .navbar {
        border-radius: 3px;
    }

    @media screen and (max-width: 600px) {
        .search {
            width: 180px;
            margin-right: 5px;
        }
    }

    @media screen and (max-width: 400px) {
        .search {
            width: 140px;
            margin-right: 3px;
        }
    }

</style>

